import anime from 'animejs'

const VueAnime = {
  install (Vue, options) {
    Vue.prototype.$anime = anime;
  }
}

export default VueAnime